import Alert from '@mui/material/Alert';
import {
  CustomContentProps,
  SnackbarProvider as NotistackSnackbarProvider,
} from 'notistack';
import React, { ReactNode } from 'react';

type SnackbarProviderProps = { children: ReactNode };

const SnackbarComponent = React.forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => (
    <Alert
      ref={ref}
      elevation={4}
      severity={props.variant === 'default' ? 'info' : props.variant}
    >
      {props.message}
    </Alert>
  ),
);

SnackbarComponent.displayName = 'SnackbarComponent';

export function SnackbarProvider({
  children,
}: Readonly<SnackbarProviderProps>) {
  return (
    <NotistackSnackbarProvider
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      maxSnack={3}
      Components={{
        warning: SnackbarComponent,
        error: SnackbarComponent,
        info: SnackbarComponent,
        default: SnackbarComponent,
        success: SnackbarComponent,
      }}
    >
      {children}
    </NotistackSnackbarProvider>
  );
}
